<script lang="ts">
    import TranslationMenu from "./TranslationMenu.svelte";

    function initMenuWithContainer(btn: HTMLButtonElement) {
        if (btn.dataset["menuattached"]) {
            return;
        }
        btn.dataset["menuattached"] = "true";


        const phrase = btn
            .closest("li")
            .querySelector(".translation__item__pharse")
            ?.textContent.trim();
        const translationContainer = btn.closest<HTMLElement>(
            "[data-translationid]"
        );
        if (!translationContainer) {
            return;
        }

        function onClose() {
            if (translationMenu) {
                btn.dataset["open"] = "false";
                translationMenu.$set({ open: false });
            }
        }

        let translationId = translationContainer.dataset["translationid"];

        const menuContainer = document.createElement("div");
        btn.parentElement.insertBefore(menuContainer, btn.nextElementSibling);

        const translationMenu = new TranslationMenu({
            target: menuContainer,
            props: { open: false, onClose, phrase, translationId, activator: btn },
        });
        (btn as any).translationMenu = translationMenu;
        btn.dataset["open"] = "true";



        setTimeout(() => {
            translationMenu.$set({open: true});
        });
    }

    function showMenu(event: Event, button: HTMLButtonElement) {
    const menu: TranslationMenu = (button as any).translationMenu;
        if (menu) {
            const open = button.dataset["open"] === "true" || false;
            button.dataset["open"] = `${!open}`;
            setTimeout(() => menu.$set({ open: !open }));
        } else {
            setTimeout(() => initMenuWithContainer(button));
        }
    }

    document.addEventListener("click", (clickEvent: Event) => {
        const targetElement = clickEvent.target;

        if (targetElement instanceof HTMLButtonElement) {
            let element = targetElement as HTMLElement;
            let matched = element.matches("button.translation-menu");;
            while (element != null && element.parentElement != null && !matched) {
                element = element.parentElement;
                matched = element.matches("button.translation-menu");
            }
            if (matched) {
                showMenu(clickEvent, element as HTMLButtonElement);
            }
        }
    });
</script>
